import { useState } from "react";
import { Link } from "react-router-dom";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import moment from "moment";
import { useRef } from "react";
import { useEffect } from "react";
// import "../scss/postHeader.scss";

const PostHeader = ({ post, isOwner, onDelete, onReport }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="user">
            <div className="userInfo">
                <img 
                    src={
                        post?.profilePic?.startsWith("http") 
                        ? post.profilePic 
                        : (post.profilePic || "/public/noAvatar.png")
                    }
                    alt="" 
                />
                
                <div className="details">
                    <Link 
                        to={`/profile/${post.userId}`} 
                        style={{ textDecoration: "none", color: "inherit" }}
                    >
                        <span className="name">
                            {post.name}
                        </span>
                    </Link>

                    <span className="date">
                        {moment(post.createdAt).fromNow()}
                    </span>
                </div>
            </div>
            
            <div className="menuContainer" ref={menuRef}>
                <div 
                    className={`iconWrapper ${menuOpen ? "active" : ""}`} 
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    <MoreHorizIcon />
                </div>

                {menuOpen && (
                    <div className="dropdownMenu">
                        {isOwner ? (
                            <div className="menuItem delete" onClick={() => { onDelete(); setMenuOpen(false); }}>
                                <DeleteOutlineIcon fontSize="small" />

                                <span>
                                    Delete Post
                                </span>
                            </div>
                        ) : (
                            <div className="menuItem report" onClick={() => { onReport(); setMenuOpen(false); }}>
                                <ReportProblemOutlinedIcon fontSize="small" />

                                <span>
                                    Report Post
                                </span>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};
export default PostHeader;